import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userPackage: [],
  loading: true,
  error: null,
};
//pankent kontrolu class true false mu apıden gelen değeri tutuyor.
const packageManagerSlice = createSlice({
  name: "packageManager",
  initialState,
  reducers: {
    fetchUserPackageStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchUserPackageSuccess(state, action) {
      state.loading = false;
      state.userPackage = action.payload;
    },
    fetchUserPackageFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchUserPackageStart,
  fetchUserPackageSuccess,
  fetchUserPackageFailure,
} = packageManagerSlice.actions;

export default packageManagerSlice.reducer;
